export const blurCurrentFocusedElement = () => {
  var _focused$blur;
  /* Blur the focus while opening the Edit aside in order to prevent scrolling
            the viewport to the last clicked element once the aside is closed.
            Only HTMLElements have the blur() method, hence the type casting and call(). */
  const focused = document.activeElement;
  focused === null || focused === void 0 || (_focused$blur = focused.blur) === null || _focused$blur === void 0 || _focused$blur.call(focused);
};